import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { ApplicationUserService } from "../services/application-user.service";

export function languageHttpInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const user = inject(ApplicationUserService).user();
  if (user) {
    const newReq = req.clone({
      headers: req.headers.append('Accept-Language', user.settings.language),
    });
    return next(newReq);
  }
  return next(req);
}
